import { Switch as MuiSwitch, switchClasses as muiSwitchClasses } from '@mui/material';
export const Switch = MuiSwitch;
export const switchClasses = muiSwitchClasses;
